import { render, staticRenderFns } from "./bookDetail.vue?vue&type=template&id=e7ec2cbe"
import script from "./bookDetail.vue?vue&type=script&lang=js"
export * from "./bookDetail.vue?vue&type=script&lang=js"
import style0 from "./bookDetail.vue?vue&type=style&index=0&id=e7ec2cbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports